import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
Amplify.configure(awsconfig);

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: "https://0a4a6b13035463644ac6c484ca4c5498@o4509010973229056.ingest.us.sentry.io/4509039091777536",
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
